import {
    IconAlertTriangle,
    IconCheck,
    IconCircleMinus,
    IconCircleOff,
    IconHelpCircle,
    IconInbox,
    IconKey,
    IconLock,
    IconMail,
    IconPlus,
    IconUserOff,
    IconX,
    type Icon,
} from '@tabler/icons-react';
import type { StatusGlyph } from '../../domain/status.js';

/** The status vocabulary's glyph tokens → Tabler icons. The only place the two meet. */
const GLYPHS: Record<StatusGlyph, Icon> = {
    check: IconCheck,
    alert: IconAlertTriangle,
    plus: IconPlus,
    inbox: IconInbox,
    off: IconCircleOff,
    help: IconHelpCircle,
    minus: IconCircleMinus,
    x: IconX,
    lock: IconLock,
    mail: IconMail,
    key: IconKey,
    userOff: IconUserOff,
};

export const glyphIcon = (glyph: StatusGlyph): Icon => GLYPHS[glyph];
